module.exports = __webpack_public_path__ + "static/media/brasserie.92049180.webp";